"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2Icon } from "lucide-react";
import { useActionState } from "react";
import { cn } from "@/utils";
import { Button } from "./button";
import { loopsSubscribe } from "./newsletter.action";
export const LoopsNewsletter = () => {
  const $ = _c(14);
  const [result_0, execute, pending] = useActionState(_temp, null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <input className="border-none bg-transparent h-full w-full appearance-none focus:outline-0 text-sm" required={true} name="email" type="email" placeholder="email@example.com" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = pending ? "w-10" : "w-22";
  let t2;
  if ($[1] !== t1) {
    t2 = cn("px-3 transition-[width]", t1);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== pending) {
    t3 = pending ? <Loader2Icon className="animate-spin" /> : "Subscribe";
    $[3] = pending;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex flex-row rounded-full p-2 pl-4 gap-2 items-center justify-between border border-neutral-300 h-12 overflow-clip has-[input:focus]:ring-2 ring-brand-500 md:pr-1">{t0}<Button variant="dark" size="small" innerClassName={t2} type="submit">{t3}</Button></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("text-center leading-pregular tracking-pregular text-pregular-500 mt-1 text-sm");
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !result_0 ? "\xA0" : result_0.error ? result_0.error : "Email added!";
  let t7;
  if ($[9] !== t6) {
    t7 = <p className={t5}>{t6}</p>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t7) {
    t8 = <form action={execute}>{t4}{t7}</form>;
    $[11] = t4;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
async function _temp(_state, formData) {
  const result = await loopsSubscribe(formData);
  return result;
}